export const locale = {
    lang: 'ar',
    data: {
        RESULT: 'النتيجة',
        CANCEL: 'إلغاء',
    }
};
